<template>
  <BasePageContainer
    v-if="initialized"
    class="pt-6">
    <page-header
      has-back>
      {{ hasCopyEvent ? '予定のコピー' : '予定作成' }}
    </page-header>
    <event-form
      :event="event"
      :is-copy="hasCopyEvent"
      @submit="createEvent" />
  </BasePageContainer>
</template>

<script>
import { format } from 'date-fns'
import EventForm from '@/components/view/EventForm.vue'
import PageHeader from '@/components/parts/PageHeader.vue'
export default {
  components: {
    PageHeader,
    EventForm
  },
  data() {
    return {
      event: {
        color: '#D7DFE4',
        title: '',
        detail: '',
        dates: [],
        categories: [],
        file: null,
      },
      initialized: false
    }
  },
  computed: {
    hasQueryDate() {
      return !!this.$route.query.date
    },
    hasCopyEvent() {
      return !!this.$route.query.copy
    }
  },
  async created() {
    if (this.hasCopyEvent) {
      this.$store.commit('startLoading')
      this.event = await this.fetchEvent(this.$route.query.copy)
      this.$store.commit('finishLoading')
      this.initialized = true
      return
    }
    this.initialized = true
  },
  methods: {
    fetchEvent(eventId) {
      return this.$axios.get(`/events/${eventId}/`).then(res => res.data)
    },
    async createEvent(formData) {
      this.$store.commit('startLoading')

      await this.$axios.post('/events/bulk_create/', formData).then((res) => {
        this.$store.commit('notify/set', {message: '予定を作成しました。'})
        const createdFirstEvent = res.data[0]
        const createdEventDate = new Date(createdFirstEvent.startAt)
        const formattedDate = format(createdEventDate, 'yyyy-MM-dd')
        this.$router.push(`/events/?date=${formattedDate}`)
      }).catch(err => {
        console.error(err)
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })

      this.$store.commit('finishLoading')
    }
  }
}
</script>

<style>

</style>